module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Cloudy-night-9262131f18cf9646a05a30ba50af72d5.svg";